import { v4 as uuidv4 } from 'uuid'; //ES6

const uuid = () => {
  let id = uuidv4();
  return id;
};

export { uuid }; //ES6
